import React from "react";
import styled from "styled-components";
import Spin from "@iso/ui/Antd/Spin/Spin";

export const Wrapper = styled.div`
  padding: 30px 20px;
  background-color: white;
  border-radis: 15px;
  margin: 10px;
  min-height: 90vh;
`;

export const PageWrapper = ({ loading, children }) => {
  return (
    <Wrapper>
      {loading ? (
        <div
          style={{
            minHeight: "150px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Spin />
        </div>
      ) : (
        children
      )}
    </Wrapper>
  );
};
